// For JSLINT
/*global document, window, o_global, o_reco
 */

var o_user = o_user || {};

o_user.goodByePage = o_user.goodByePage || {};

o_user.goodByePage.presenterBuilder = function (document, recoApi) {
    'use strict';

    function showRecommendationCinema() {
        var container = document.getElementById("us_js_goodByePageCinemaContainer");
        if (container !== null) {
            recoApi.loadRecommendationsForEntryPage({targetElement: container, dresonRule: "(und.(ja).(~.(v.1)))", pageType: "LOGOUT", menuItemPath: "user/goodbye"});
        }
    }

    return {
        showRecommendationCinema: showRecommendationCinema
    };
};
